import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import setFilterQuery from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { CustomHandlerWithResult } from "@tLinc/Store/CustomHandlerCreator/CustomHandlerCreator";
import cloneDeep from "lodash/cloneDeep";

type HandlerType = CustomHandlerWithResult<ProductFilters, ProductFilters>;

export const GetCurrentFilters: HandlerType = props => {
    props.result = cloneDeep(props.getState().LINCData.myProductsReducer.productFilters);
};

export const RemoveAttributeValueFilters: HandlerType = props => {
    const currentFilters = props.getState().LINCData.myProductsReducer.productFilters;
    const selectedAttrId = props.parameter.attributeValueIds?.[0];
    if (selectedAttrId) {
        const updatedAttributeTypeFilters = currentFilters.attributeValueIds.filter(
            (attr: string | undefined) => attr !== selectedAttrId,
        );
        props.result.attributeValueIds = updatedAttributeTypeFilters;
    }
};

export const RemoveBrandValueFilters: HandlerType = props => {
    const currentFilters = props.getState().LINCData.myProductsReducer.productFilters;
    const selectedBrandId = props.parameter.brandIds?.[0];
    if (selectedBrandId) {
        const updatedBrandTypeFilters = currentFilters.brandIds.filter(
            (brandId: string | undefined) => brandId !== selectedBrandId,
        );
        props.result.brandIds = updatedBrandTypeFilters;
    }
};

export const DispatchSetProductFilters: HandlerType = props => {
    props.dispatch({
        type: "Custom/MyProducts/SetMyProductFilters",
        result: props.result,
    });
};

export const chain = [
    GetCurrentFilters,
    RemoveAttributeValueFilters,
    RemoveBrandValueFilters,
    DispatchSetProductFilters,
];

const customRemoveMyProductsFilters = createHandlerChainRunner(chain, "RemoveProductFilters");
export default customRemoveMyProductsFilters;
